import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { combineLatest, Observable, of, Subject } from 'rxjs';
import { delay, filter, take } from "rxjs/operators";
import { AnnualIncome, Country, IncomeSource, Occupation, State } from "src/app/shared/model/models";
import { FacadeService } from "src/app/shared/service-facade/facade.service";

@Injectable({
  providedIn: 'root'
})
export class CatalogDataResolver implements Resolve<boolean> {
  constructor(
    private facadeService: FacadeService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    return this.facadeService.getCatalogData();
  }
}
